














































































































































/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
// import { Component, Vue } from "vue-property-decorator";
import { Component, Vue, Watch } from "vue-property-decorator";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
import ButtonInspect from "@/components/common/button/ButtonInspect.vue";
import {
  Buhin,
  BuhinCategory,
  SubBuhinCategory,
  BuhinDetail
} from "@/model/Buhin";
import Number from "@/shared/filters/Number";
import { Getter, Action } from "vuex-class";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Utils } from "@/service/util";
import { MESSAGE } from "@/model/Message";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputString from "@/components/common/input/InputString.vue";
import { InspectService } from "@/service/inspectService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import { InspectDescriptions } from "@/model/InspectGensha";
import { InspectRecommendSubItem } from "@/model/InspectRecommend";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { WORK_AND_BUHIN_MODE, WorkAndBuhinMode } from "@/model/WorkAndBuhinData";
import { PartSelectionPageService } from "@/service/PartSelectionPageService";

// refactor : 現状はmodel式。serviceにはなっていない
import * as PartSelectionPageServiceModel from "@/model/PartSelectionPageService";

@Component({
  filters: {
    Number
  },
  components: {
    ButtonInspect,
    SaveDialog,
    ConfirmDialog,
    InputString,
    InputNumber,
    WorkAndBuhin,
    ButtonInspectGroup
  }
})
export default class PartSelection extends Vue {
  pageService: PartSelectionPageServiceModel.PartSelectionPageService;
  inspectList: InspectDescriptions[] = [];
  buhinList: Buhin[] = [];
  activeTab1: number = 0;
  activeTab2: number = 0;
  buhinCategory: BuhinCategory[] = [];
  buhinContent: any[] = [];
  oldBuhinContent: any[] = [];
  selFilter: any[] = [];
  Filter: any[] = [];
  arrActiveWork: string[] = [];
  activeWork: string = "";
  listBuhin: any = [];
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = true;
  dialogSeibiVisible: boolean = false;
  isAdd: boolean = false;
  isManual: boolean = false;
  seibi: any = {};
  inspectService: InspectService;
  ippanSeibiService: IppanSeibiService;
  seibiEditedIndex: number = -1;
  activeInspect: any = {};
  activeInspectId: number = -1;
  listRecommend: any = [];
  listInspectByResult: InspectDescriptions[][] = [];
  isInspect: boolean = false;
  msgAskMD15: string = MESSAGE.AskMD15;
  displayDialogEdit: boolean = false;
  editTitle: string = "";
  editItem: any = {};
  hideTriangle: boolean = false;

  public utils: Utils = new Utils();

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("katashiki", { namespace: "CarSelection" })
  katashiki: string;

  @Getter("engineKatashiki", { namespace: "CarSelection" })
  engineKatashiki: string;

  // 2022-01-31 morisako kobac-free add [START]
  @Action("remove", { namespace: "SeibiIds" })
  removeSeibiId: any;
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: string;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  @Getter("freeOfChargeLabelFull", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  $refs!: {
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    inputManualSeibi: InputString;
    workBuhinRef: WorkAndBuhin;
    confirmDialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  applyWorkBuhinRefAction(
    action: PartSelectionPageServiceModel.PartSelectionWorkBuhinRefAction
  ) {
    if (action.type == "selectWork") {
      this.$refs.workBuhinRef.onSelectWork(
        action.work,
        action.index != null ? action.index : 0,
        !!action.isManual,
        !!action.forceSelect
      );
    } else if (action.type == "noSeibi") {
      this.$refs.workBuhinRef.onNoSeibi();
    } else if (action.type == "resetBuhin") {
      this.$refs.workBuhinRef.resetBuhin();
      this.$forceUpdate();
    } else if (action.type == "hideBuhin") {
      this.$refs.workBuhinRef.hideBuhin();
    } else if (action.type == "reInitBuhin") {
      this.$refs.workBuhinRef.reInitBuhin(action.data);
    } else if (action.type == "showMsgConfirm") {
      this.$refs.workBuhinRef.showMsgConfirm();
    }
  }

  applySelectState(state: PartSelectionPageServiceModel.PartSelectionSelectState) {
    this.isInspect = state.isInspect;
    this.activeInspectId = state.activeInspectId;
    this.$set(this, "activeInspect", state.activeInspect);
    this.applyWorkBuhinRefAction(state.refAction);
  }

  initData(res: any, first: boolean = false) {
    const initialState = this.pageService.buildInitialDataState(res);
    if (initialState.hasInspectList) {
      this.inspectList = initialState.inspectList;
      this.listRecommend = initialState.listRecommend;
      const inspectListResult = this.inspectService.getinspectListByResult(
        this.inspectList
      );

      this.$set(this, "listInspectByResult", inspectListResult);

      const initRefActions = this.pageService.buildInitRefActions({
        first,
        activeInspectId: this.activeInspectId,
        isInspect: this.isInspect,
        listInspectByResult: inspectListResult,
        inspectList: this.inspectList,
        listRecommend: this.listRecommend
      });
      if (initRefActions.visibilityAction.type != "none") {
        this.applyWorkBuhinRefAction(initRefActions.visibilityAction);
      }
      this.applySelectState(initRefActions.selectState);
    }
  }

  created() {
    this.$emit("onactivepage", this.$route.name);
    this.pageService = new PartSelectionPageService();
    this.inspectService = new InspectService();
    this.ippanSeibiService = new IppanSeibiService();
    this.loading = true;
    this.getData(true);
  }

  getData(isFirst: boolean = false) {
    this.pageService.getPartSelection(this.uketsukeExtendsId).then(
      (res: any) => {
        this.loading = false;
        this.initData(res, isFirst);
      },
      (err: any) => {
        this.loading = false;
        this.onError(err);
      }
    );
  }

  onClickInspect(inspect: any) {
    this.applySelectState(
      this.pageService.buildInspectSelectState(inspect)
    );
  }

  onClickReccomend(recCate: any, index: number) {
    this.applySelectState(this.pageService.buildRecommendSelectState(recCate));
  }

  isActiveInspect(inspect: any) {
    if (inspect.sknInspectDescriptionId && this.isInspect) {
      return this.activeInspectId == inspect.sknInspectDescriptionId;
    }
    if (inspect.sknRecommendInspectCategoryId && !this.isInspect) {
      return this.activeInspectId == inspect.sknRecommendInspectCategoryId;
    }
  }

  onRegister() {
    const status = this.inspectService.getRegisterStatusMD15(this.inspectList);
    const registerActions = this.pageService.buildRegisterActions({
      pageName: this.$route.name,
      status,
      registerNotCompleteStatus: NAVIGATION_STATUS.REGISTER_NOTCOMPLETE
    });
    if (registerActions.shouldOpenConfirmDialog) {
      this.$refs.confirmDialog.onOpen();
    }
    if (registerActions.shouldEmitSaveSpentTime) {
      this.$emit("saveSpentTime", true);
    }
    if (registerActions.shouldEmitRegister) {
      this.$emit("onregister", registerActions.registerPayload);
    }
  }

  onSave() {
    const saveActions = this.pageService.buildTemporarySaveActions();
    if (saveActions.shouldEmitSaveSpentTime) {
      this.$emit("saveSpentTime");
    }
    if (saveActions.shouldOpenSaveDialog) {
      this.$refs.saveDialog.onOpen();
    }
  }

  saveInspectItem(inspectItem: InspectDescriptions, changeList: any) {
    if (this.isInspect) {
      const objForSave = this.pageService.buildInspectSaveItem({
        inspectItem,
        changeList
      });
      // sendSocket:ソケット仮04
      // sendSocket:ソケット仮22
      // sendSocket:ソケット仮06
      // 部品選択側からの保存動作なので、ローディングと完了メッセージはこちらで動かす
      this.loading = true;
      this.pageService.savePartSelection(objForSave).then(
        (res: any) => {
          const successActions = this.pageService.buildSavePartSelectionSuccessActions({
            status: res.status,
            successStatus: 200,
            body: res.body
          });
          if (successActions.shouldStopLoading) {
            this.loading = false;
          }
          if (successActions.shouldInitData) {
            this.initData(res.body);
          }
          if (successActions.shouldShowWorkBuhinConfirm) {
            this.applyWorkBuhinRefAction(this.pageService.buildShowMsgConfirmRefAction());
          }
        },
        error => {
          const errorActions = this.pageService.buildSavePartSelectionErrorActions({
            inspectItem
          });
          if (errorActions.shouldStopLoading) {
            this.loading = false;
          }
          console.error("error", error);
          if (errorActions.shouldNotifyError) {
            this.$notify.error({
              title: "エラー",
              message: errorActions.errorMessage
            });
          }
        }
      );
    }
  }

  onError(res: any) {
    this.loading = false;
    this.errorMsg = this.utils.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  inspectResClass(index: number) {
    return this.inspectService.inspectResClassTitle(index);
  }

  onConfirmBuhin(data: { inspectItem: InspectDescriptions; seibi: any, changeList: any }) {
    const saveState = this.pageService.buildConfirmSaveState(data);
    if (saveState.isRecommend) {
      this.editItem = saveState.editItem;
      this.onSaveInspectResult(saveState.changeList, true);
    } else {
      this.saveInspectItem(saveState.inspectItem, saveState.changeList);
    }
  }

  onCallbackDeleteManualSeibi(sknUketsukeInspectId: any) {
    if (this.pageService.shouldSendManualSeibiDeleteSocket(sknUketsukeInspectId)) {
      // sendSocket:ソケット仮04
      this.pageService.sendSocket(
        this.uketsukeExtendsId,
        sknUketsukeInspectId
      );
    }
  }

  callbackDeleteBuhin(data: any) {
    const callbackState = this.pageService.buildDeleteBuhinCallbackState(data);
    this.editItem = callbackState.editItem;
    if (callbackState.shouldSaveInspectResult) {
      this.onSaveInspectResult();
    }
  }

  inspectSuccess(inspect: InspectDescriptions) {
    return this.pageService.isInspectSuccess(inspect);
  }

  seibiRecSuccess(index: number) {
    return this.pageService.isRecommendSuccess(this.listRecommend[index]);
  }

  showTitle(index: number) {
    return this.pageService.shouldShowTitle(this.listInspectByResult[index]);
  }

  onConfirmSave() {
    const confirmActions = this.pageService.buildConfirmRegisterActions({
      pageName: this.$route.name,
      registerNotCompleteStatus: NAVIGATION_STATUS.REGISTER_NOTCOMPLETE
    });
    if (confirmActions.shouldEmitSaveSpentTime) {
      this.$emit("saveSpentTime", true);
    }
    if (confirmActions.shouldEmitRegister) {
      this.$emit("onregister", confirmActions.registerPayload);
    }
  }

  showDialogEdit(event: any, item: any) {
    event.stopPropagation();
    this.onEditResult(item);
  }

  onEditResult(item: any) {
    const editDialogState = this.pageService.buildEditDialogState({
      item,
      isNoSeibi:
        item.sknInspectType != INSPECT_TYPE.RECOMMEND &&
        item.sknInspectType != INSPECT_TYPE.RECOMMEND_MANUAL
          ? this.isNoSeibi(item)
          : false
    });
    this.editTitle = editDialogState.editTitle;
    this.displayDialogEdit = editDialogState.displayDialogEdit;
    this.editItem = editDialogState.editItem;
    this.hideTriangle = editDialogState.hideTriangle;
  }

  onInspectBtnChange(result: number) {
    const changeState = this.pageService.buildInspectButtonChangeState({
      item: this.editItem,
      result
    });
    Object.assign(this.editItem, changeState.itemState);
    if (changeState.shouldNormalizeInspectParam) {
      // 2022-01-31 morisako kobac-free add [START]
      let objForSave: InspectDescriptions = this.removeInspectParam(this.editItem);
      this.editItem = this.utils.deepCopy(objForSave);
      // 2022-01-31 morisako kobac-free add [END]
    }
  }

  onSaveInspectResult(changeList: any = null, isWorkBuhin: boolean = false) {
    this.displayDialogEdit = false;
    this.editItem = this.pageService.normalizeSaveEditItem(this.editItem);
    const saveRequestState = this.pageService.buildSaveRequestState({
      editItem: this.editItem,
      uketsukeExtendsId: this.uketsukeExtendsId,
      changeList
    });
    if (saveRequestState.shouldClearActiveInspectId) {
      this.activeInspectId = -1;
    }

    // 部品選択側からの保存指示の場合、ローディングと完了メッセージはこちらで動かす
    const loadingActions = this.pageService.buildSaveLoadingActions({
      isWorkBuhin
    });
    if (loadingActions.shouldStartLoading) { this.loading = true; }
    const req = this.pageService.saveByRequestState(saveRequestState);

    if (req) {
      req.then(
        (res: any) => {
          const successActions = this.pageService.buildSaveSuccessActions({
            status: res.status,
            successStatus: 200,
            isSocket: saveRequestState.isSocket,
            sendSocket: saveRequestState.sendSocket,
            isWorkBuhin
          });
          if (successActions.shouldReload) {
            if (successActions.shouldSendSocket) {
              // sendSocket:ソケット仮04
              this.pageService.sendSocket(
                this.uketsukeExtendsId,
                this.editItem.sknUketsukeInspectId
              );
            }
            this.getData();
            if (successActions.shouldShowWorkBuhinConfirm) {
              this.applyWorkBuhinRefAction(this.pageService.buildShowMsgConfirmRefAction());
            }
          } else if (loadingActions.shouldStartLoading) {
            this.loading = false;
          }
        },
        error => {
          if (loadingActions.shouldStartLoading) {
            this.loading = false;
          }
          const nm =
            this.editItem.sknInspectDescriptionNm ||
            this.editItem.sknRecommendInspecSeibiNm;
          this.$notify.error({
            title: "エラー",
            message: nm
          });
        }
      );
    }
    if (!req && loadingActions.shouldStartLoading) {
      this.loading = false;
    }
  }

  get recommendLength() {
    return this.pageService.getRecommendLength(this.listRecommend);
  }

  isNoSeibi(inspect: InspectDescriptions) {
    const list = [
      "前方ｴｱﾊﾞｯｸﾞ警告灯",
      "側方ｴｱﾊﾞｯｸﾞ警告灯",
      "ﾌﾞﾚｰｷ警告灯",
      "ABS警告灯",
      "ｴﾝｼﾞﾝ警告灯",
      "自動ﾌﾞﾚｰｷ",
      "ﾚｰﾝｷｰﾌﾟ",
      "自動運行装置"
    ];
    return this.pageService.isNoSeibi({
      inspect,
      inspectServiceNoSeibi: this.inspectService.isNoSeibi(inspect),
      fixedNoSeibiNames: list
    });
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.pageService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      this.$router.push({ name: "reservation" });
    });
  }

  removeInspectParam(inspectItem: InspectDescriptions, copy: boolean = true) {
    let objForSave = {} as InspectDescriptions;
    if (copy) {
      objForSave = this.utils.deepCopy(inspectItem);
    } else {
      objForSave = inspectItem;
    }
    delete objForSave.status;
    delete objForSave.showWork;
    delete objForSave.showValue;
    delete objForSave.isSaving;
    if (objForSave.inspectResult == InspectButtonValue.CIRCLE) {
      const deleteApiActions = this.pageService.buildCircleDeleteApiActions(
        objForSave
      );
      if (deleteApiActions.shouldDeleteManualItems) {
        deleteApiActions.deleteTargets.manualSeibiIds.forEach((id: any) => {
          this.pageService.deleteManualSeibi({
            sknUketsukeManualSeibiId: id,
            uketsukeExtendsId: this.uketsukeExtendsId
          });
        });
        deleteApiActions.deleteTargets.manualBuhinIds.forEach((id: any) => {
          this.pageService.deleteManualBuhin(id);
        });
      }
      objForSave = this.pageService.applyCircleDeleteState(objForSave);
    }

    return this.pageService.normalizeInspectParamForSave(objForSave);
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Watch("seibiMenuCd")
  reInitData() {
    this.loading = true;
    this.getData();
  }

  get workAndBuhinMode(): WorkAndBuhinMode {
    return this.isInspect
      ? WORK_AND_BUHIN_MODE.PART_SELECTION_INSPECT
      : WORK_AND_BUHIN_MODE.PART_SELECTION_RECOMMEND;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
